<template>
  <v-dialog v-model="modelValue" max-width="1200px" content-class="rounded-lg" transition="dialog-transition">
    <v-sheet class="rounded-lg" color="white pa-4 d-flex flex-column">
      <div class="d-flex flex-row justify-space-between">
        <div>
          <slot />
        </div>
        <v-btn icon color="gray" class="align-self-start" @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-sheet>
  </v-dialog>
</template>

<script>
import { ComputedOptions } from 'vue'
import { Method } from '@/_typedefs'

export default {
  name: 'BaseConductWarning',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /** @type {ComputedOptions<boolean>} */
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    /** @type {Method<[]>} */
    close() {
      this.modelValue = false
    },
  },
}
</script>

<style></style>
